/* Zapp scroll-reveal: IntersectionObserver toggles .is-inview on [data-zapp-reveal]
   elements (single reveal or staggered grids via .zapp-stagger). Sections opt in
   through their "Enable scroll animation" schema setting, which prints the attribute. */
(function () {
  var docEl = document.documentElement;
  docEl.classList.add('zapp-motion-ready');

  if (!('IntersectionObserver' in window)) {
    docEl.classList.remove('zapp-motion-ready');
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  function observeAll(root) {
    (root || document).querySelectorAll('[data-zapp-reveal]:not(.is-inview)').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      observeAll();
    });
  } else {
    observeAll();
  }

  /* Re-scan when the theme editor re-renders a section */
  document.addEventListener('shopify:section:load', function (event) {
    observeAll(event.target);
  });
})();
